import { map } from "lodash";
import MainLayout from "@/Component/MainLayout";
import Breadcrumbs from "@/Component/Common/Breadcrumbs";
import CustomerReviewsFull from "@/Component/Common/CustomerReviewsFull";
import DownloadNH from "@/Component/Common/DownloadNH";
import FaqSection from "@/Component/Common/FaqSection";
import SeeTheWorld from "@/Component/Common/SeeTheWorld";
import CountrywiseCard from "@/Component/Module/Deals/CountrywiseCard";
import CountryCityHero from "./CountryCityHero/CountryCityHero";
import styles from "./CountryCity.module.css";

export default function CountryCity({
  slug = "",
  pageData = null,
  initialReviewsList = null,
}) {
  const services = pageData?.services || [];
  const faqs = pageData?.faqs || [];

  return (
    <MainLayout hideHeader>
      <CountryCityHero hero={pageData?.hero} />
      <Breadcrumbs />
      {pageData?.heading?.title || pageData?.heading?.description ? (
        <SeeTheWorld
          title={pageData.heading.title || undefined}
          text={pageData.heading.description || undefined}
        />
      ) : null}

      {map(services, (service) => (
        <div key={service.id} className={styles.sectionBlock}>
          <CountrywiseCard
            titleFirst={service.titleFirst}
            titleLast={service.titleLast}
            description={service.description}
            packageList={service.items}
            moduleType={service.moduleType}
          />
        </div>
      ))}

      {!services.length ? (
        <p className={`nodata ${styles.emptyState}`}>No packages available at the moment.</p>
      ) : null}

      <CustomerReviewsFull
        moduleType="CountryCityPage"
        slug={slug}
        initialReviewsList={initialReviewsList}
      />

      {faqs.length ? (
        <FaqSection
          items={faqs}
          className={styles.faqSection}
        />
      ) : null}

      <DownloadNH />
    </MainLayout>
  );
}
